(function () {
  function initTabs(root) {
    var wrapper = root.querySelector(".main-product-info-tabs-wrapper");
    if (!wrapper) return;

    var buttons = wrapper.querySelectorAll(".main-product-tabs-btn");
    var panels = wrapper.querySelectorAll(".main-product-tabs-content");
    var activeClass = "is-active";

    function activate(index) {
      buttons.forEach(function (btn, i) {
        btn.classList.toggle(activeClass, i === index);
      });
      panels.forEach(function (panel, i) {
        panel.classList.toggle(activeClass, i === index);
      });
    }

    buttons.forEach(function (btn, i) {
      btn.addEventListener("click", function () {
        activate(i);
      });
    });
  }

  function initGallery(root) {
    var wrap = root.querySelector(".main-product-gallery-wrapper");
    if (!wrap || typeof window.Splide === "undefined") return;

    var mainEl = wrap.querySelector(".main-product-gallery__main");
    var thumbsEl = wrap.querySelector(".main-product-gallery__thumbs");
    if (!mainEl || !thumbsEl) return;

    var main = new Splide(mainEl, {
      type: "fade",
      rewind: true,
      pagination: false,
      arrows: false,
      gap: "10px",
    });

    var thumbs = new Splide(thumbsEl, {
      perPage: 6,
      gap: 8,
      rewind: true,
      pagination: false,
      arrows: false,
      isNavigation: true,
      breakpoints: {
        360: { perPage: 3, gap: 4 },
        768: { perPage: 4, gap: 4 },
        1024: { perPage: 6, gap: 14 },
      },
    });

    main.sync(thumbs);
    main.mount();
    thumbs.mount();
  }

  function initSection(root) {
    initTabs(root);
    initGallery(root);
  }

  document.querySelectorAll(".main-product-container").forEach(initSection);
})();
